// Media accepted on questions (stem, options, insights).
//
// Images already flowed end-to-end before this; GIF, audio and video are new.
// Caps are per-class because the classes behave very differently: a JPEG can be
// re-encoded down to fit, a GIF cannot (see compressImage note below) and an
// mp4 is simply large.

export const MAX_QUESTION_GIF_SIZE_KB = 5120 // 5 MB
export const MAX_QUESTION_AUDIO_SIZE_KB = 10240 // 10 MB
export const MAX_QUESTION_VIDEO_SIZE_KB = 51200 // 50 MB

// PNG/JPEG only. GIF is deliberately excluded: compressImage() re-encodes through
// a canvas, which keeps the first frame and silently drops the animation. GIFs are
// size-checked instead, never compressed.
export const COMPRESSIBLE_IMAGE_MIME_TYPES = ['image/png', 'image/jpeg']

export const ALLOWED_IMAGE_MIME_TYPES = [...COMPRESSIBLE_IMAGE_MIME_TYPES, 'image/gif']

export const ALLOWED_AUDIO_MIME_TYPES = ['audio/mpeg', 'audio/mp3', 'audio/mp4', 'audio/ogg', 'audio/wav', 'audio/x-wav', 'audio/webm']

export const ALLOWED_VIDEO_MIME_TYPES = ['video/mp4', 'video/webm', 'video/ogg']

export const ALLOWED_MEDIA_MIME_TYPES = [...ALLOWED_IMAGE_MIME_TYPES, ...ALLOWED_AUDIO_MIME_TYPES, ...ALLOWED_VIDEO_MIME_TYPES]

/** For <input accept="..."> and SunEditor/TinyMCE picker filters. */
export const AUDIO_ACCEPT_ATTRIBUTE = ALLOWED_AUDIO_MIME_TYPES.join(',')
export const VIDEO_ACCEPT_ATTRIBUTE = ALLOWED_VIDEO_MIME_TYPES.join(',')
export const IMAGE_ACCEPT_ATTRIBUTE = ALLOWED_IMAGE_MIME_TYPES.join(',')

/** Extension used when a blob arrives without a usable filename (e.g. clipboard paste). */
export const MIME_TYPE_EXTENSIONS: Record<string, string> = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/gif': 'gif',
  'audio/mpeg': 'mp3',
  'audio/mp3': 'mp3',
  'audio/mp4': 'm4a',
  'audio/ogg': 'ogg',
  'audio/wav': 'wav',
  'audio/x-wav': 'wav',
  'audio/webm': 'weba',
  'video/mp4': 'mp4',
  'video/webm': 'webm',
  'video/ogg': 'ogv',
}
